import React from 'react';
import LazyLoad from 'react-lazyload';
import finaldiscussion from "../finalist_photos/finalsdiscussion-min.webp";
import GroupsIcon from '@mui/icons-material/Groups';
import SchoolIcon from '@mui/icons-material/School';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MenuBookIcon from '@mui/icons-material/MenuBook';

function StartIROClub() {
  const benefits = [
    {
      icon: <GroupsIcon style={{ fontSize: '32px', color: '#004d99' }} />,
      title: "Build a Community",
      description: "Connect with like-minded students passionate about research and scientific inquiry."
    },
    {
      icon: <SchoolIcon style={{ fontSize: '32px', color: '#004d99' }} />,
      title: "Develop Skills",
      description: "Help members develop critical thinking, analytical reasoning, and research skills."
    },
    {
      icon: <EmojiEventsIcon style={{ fontSize: '32px', color: '#004d99' }} />,
      title: "Compete Together",
      description: "Prepare as a team for IRO competitions and celebrate achievements together."
    },
    {
      icon: <MenuBookIcon style={{ fontSize: '32px', color: '#004d99' }} />,
      title: "Access Resources",
      description: "Get exclusive club materials, presentation slides, and study guides."
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "60px 0 50px 0" }}>
        <div className="container">
          <div style={{ maxWidth: "800px" }}>
            <h1 style={{
              fontSize: "clamp(2rem, 4vw, 2.5rem)",
              fontWeight: "700",
              color: "#1a1a2e",
              marginBottom: "16px",
              letterSpacing: "-0.02em"
            }}>
              Start an IRO Club
            </h1>
            <p style={{
              fontSize: "1.1rem",
              color: "#555",
              lineHeight: "1.7"
            }}>
              Bring the International Research Olympiad to your school by starting an official IRO club. Use our comprehensive guide to get started.
            </p>
          </div>
        </div>
      </div>

      <div className="container" style={{ padding: "50px 0 80px 0" }}>
        {/* Benefits Section */}
        <div style={{ marginBottom: "60px" }}>
          <h2 style={{
            fontSize: "1.75rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "32px"
          }}>
            Why Start an IRO Club?
          </h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "24px"
          }}>
            {benefits.map((benefit, index) => (
              <div
                key={index}
                style={{
                  background: "#fff",
                  borderRadius: "12px",
                  padding: "28px",
                  boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3"
                }}
              >
                <div style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "12px",
                  backgroundColor: "rgba(0, 77, 153, 0.08)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "16px"
                }}>
                  {benefit.icon}
                </div>
                <h3 style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#1a1a2e",
                  marginBottom: "8px"
                }}>
                  {benefit.title}
                </h3>
                <p style={{
                  fontSize: "0.95rem",
                  color: "#555",
                  lineHeight: "1.6",
                  margin: 0
                }}>
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Image Section */}
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "40px",
          alignItems: "center",
          marginBottom: "60px"
        }}>
          <div style={{ flex: "1", minWidth: "300px" }}>
            <LazyLoad height={300} offset={100} once>
              <img
                src={finaldiscussion}
                alt="IRO Club Discussion"
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  borderRadius: "16px",
                  boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)"
                }}
              />
            </LazyLoad>
          </div>
          <div style={{ flex: "1", minWidth: "300px" }}>
            <h2 style={{
              fontSize: "1.75rem",
              fontWeight: "600",
              color: "#1a1a2e",
              marginBottom: "16px"
            }}>
              Club Resources
            </h2>
            <p style={{ fontSize: "1.05rem", color: "#555", lineHeight: "1.8", marginBottom: "20px" }}>
              We provide everything you need to run a successful IRO club, including meeting agendas, presentation slides, practice materials, and guidelines for organizing study sessions.
            </p>
            <a
              href="/files/club-presentation-slides"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 24px",
                backgroundColor: "#004d99",
                color: "#fff",
                borderRadius: "10px",
                textDecoration: "none",
                fontSize: "1rem",
                fontWeight: "600"
              }}
            >
              View Presentation Slides
            </a>
          </div>
        </div>

        {/* Club Guide Document */}
        <div>
          <h2 style={{
            fontSize: "1.75rem",
            fontWeight: "600",
            color: "#1a1a2e",
            marginBottom: "24px"
          }}>
            IRO Club Guide
          </h2>
          <div style={{
            background: "#fff",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
            border: "1px solid #e8eef3"
          }}>
            {/* Header */}
            <div style={{
              padding: "20px 28px",
              borderBottom: "1px solid #e8eef3",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px"
            }}>
              <h3 style={{
                fontSize: "1.1rem",
                fontWeight: "600",
                color: "#1a1a2e",
                margin: 0
              }}>
                Complete Club Setup Guide
              </h3>
              <a
                href="https://docs.google.com/document/d/1P7lshfP_WtwIy_rqoCk3_5aAbd9ftlj-3pH4FTC0LrU/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  backgroundColor: "#004d99",
                  color: "#fff",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  fontWeight: "500"
                }}
              >
                Open in Google Docs
              </a>
            </div>

            {/* Embedded Document */}
            <iframe
              title="IRO Club Guide"
              src="https://docs.google.com/document/d/1P7lshfP_WtwIy_rqoCk3_5aAbd9ftlj-3pH4FTC0LrU/preview"
              style={{
                width: "100%",
                height: "800px",
                border: "none"
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StartIROClub;
